import { toFormattedString } from 'foundations-components/transitional/utils/SimpleDate';
import { URL_DATE_FORMAT } from 'FormsUI/constants/DateFormats';
const isDateType = type => type && type !== 'CUSTOM';
const getDateFormatted = date => toFormattedString(date, URL_DATE_FORMAT);
export const getUrlParamsForDashboardDateRange = ({
  type,
  startDate,
  endDate
}) => ({
  dateType: isDateType(type) ? type : null,
  startDate: startDate && !isDateType(type) ? getDateFormatted(startDate) : null,
  endDate: endDate && !isDateType(type) ? getDateFormatted(endDate) : null
});
export default getUrlParamsForDashboardDateRange;